import Typography from "antd/lib/typography";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

import { CheckContained } from "@sol/uikit/core/icons/General/CheckContained";
import { XCircleContained } from "@sol/uikit/core/icons/General/XCircleContained";
import { Tag, type TagProps } from "@sol/uikit/data-display/Tag/Tag";

export type SkillLevelItem = {
    id: string;
    status: TagProps["color"];
    title: string;
};

type Props = {
    title: string;
    assessment: SkillLevelItem[];
    selfAssessment: SkillLevelItem[];
    className?: string;
} & ComponentProps<"div">;

const SkillEvaluation = ({ title, assessment, selfAssessment, className, ...divProps }: Props) => {
    const [t] = useTranslation();

    return (
        <div {...divProps} className={className}>
            <Typography.Title level={3}>{title}</Typography.Title>
            <div className="mt-4" data-cy="skill-evaluation-assessment">
                <Typography.Text className="text-color-ant-secondary">
                    {t("component.shared.SkillEvaluation.assessment")}
                </Typography.Text>
                <div className="flex gap-4">
                    {assessment.map(level => (
                        <Tag
                            className="flex-1 justify-center"
                            key={level.id}
                            color={level.status}
                            data-variant={level.status}
                            icon={
                                level.status === "success" ? (
                                    <CheckContained variant="antd" />
                                ) : level.status === "error" ? (
                                    <XCircleContained variant="antd" />
                                ) : undefined
                            }
                        >
                            {level.title}
                        </Tag>
                    ))}
                </div>
            </div>
            <div className="mt-2" data-cy="skill-evaluation-self-assessment">
                <Typography.Text className="text-color-ant-secondary">
                    {t("component.shared.SkillEvaluation.selfAssessment")}
                </Typography.Text>
                <div className="flex gap-4">
                    {selfAssessment.map(level => (
                        <Tag
                            data-variant={level.status}
                            className="flex-1 justify-center"
                            key={level.id}
                            color={level.status}
                            icon={
                                level.status === "success" ? (
                                    <CheckContained variant="antd" />
                                ) : level.status === "error" ? (
                                    <XCircleContained variant="antd" />
                                ) : undefined
                            }
                        >
                            {level.title}
                        </Tag>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SkillEvaluation;
